
















































import {
	Component,
	Vue
} from "vue-property-decorator";

import vFreeApply from '@/components/v-free-apply.vue';
import defaultItem from "@/utils/defaultItem";
@Component({
	components: {
		vFreeApply
	},
})
export default class About extends Vue {
	private positionList = defaultItem.positionList();
	private phone = '15359238919';
	private email = '';
}
